<script>
import {mapState} from "vuex";
import { cloneDeep } from 'lodash';
import InfiniteLoading from 'vue-infinite-loading';
import { timeSince } from '../state/helpers';

export default {
    name: "facebookPosts",
    components: {
        InfiniteLoading
    },
    data () {
        return {
            posts: [],
            dateOptions: { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false },
            page: 0,
        };
    },
    mounted () {
        if (this.facebook.posts.data.length > 0) {
            this.page = this.currentPage;
            this.posts = cloneDeep(this.facebook.posts.data).map((post) => {
                delete post.insights.comments;
                delete post.insights.engagement;
                post.info.published_at = new Date(post.info.published_at).toLocaleDateString(undefined, this.dateOptions);
                post.insights.engagement_rate = post.insights.engagement_rate + '%';
                return post;
            });
        }
    },
    computed: {
        timeAgo() {
            if (!this.facebook.overview.posts_touched_at) {
                return '';
            }
            return timeSince(new Date(this.facebook.overview.posts_touched_at));
        },
        ...mapState('user', {
            facebook: (state) => state.facebook,
            currentPage: (state) => state.facebook.posts.current_page,
            lastPage: (state) => state.facebook.posts.last_page
        })
    },
    methods: {
        async infiniteHandler ($state) {

            this.$store.commit('loader/START_LOADING');
            try {
                const newPosts = await this.$store.dispatch('user/getFacebookPosts', { pageNumber: this.page + 1});
                this.posts.push(...newPosts);
                this.page += 1;
                $state.loaded();
            } finally {
                $state.complete();
                this.$store.commit('loader/END_LOADING');
            }
        }
    }
}
</script>

<template>
    <div>
        <div v-if="timeAgo" class="text-muted text-right last-updated">
            <i class="bx bx-time-five"  style="vertical-align:middle;"></i> Updated {{ timeAgo }} ago
        </div>
        <div v-if="posts.length === 0">
            <h5 class="text-muted text-center my-4">
                {{ $t('No posts.')}}
            </h5>
        </div>
        <div v-for="post in posts" :key="post.published_at" class="tab-section p-3 mt-4">
            <div class="row">
                <div class="col-12 col-md-auto text-center">
                    <div class="image-container">
                        <img :src="post.info.media_url" alt class="img-fluid" style="max-height:250px;margin: auto;"/>
                    </div>
                </div>
                <div class="col-12 col-md mt-4 mt-md-0">
                    <div class="row flex-column justify-content-end">
                        <div class="col mt-3">
                            <div class="row">
                                <div class="col">
                                    <h5 class="m-0 timestamp">{{ post.info.published_at }}</h5>
                                </div>
                                <div class="col-auto">
                                    <i class="bx bxl-facebook-square" style="color: #3A5897;vertical-align:middle; font-size:25px;"></i> <span class="username">{{ post.info.username }}</span>
                                </div>
                                <div class="col-12 mb-xl-2 mt-2">
                                    <a :href="post.info.permalink" target="_blank">Visit post <i class="bx bx-link-external" style="vertical-align:middle; font-size:1.1em;"></i> </a>
                                </div>
                                <div class="col-12">
                                    <p class="caption text-muted my-3">{{ post.info.title }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col mt-0 mt-xl-2">
                            <div class="data-container pt-2">
                                <div class="row">
                                    <div class="col-6 col-xl-2 mb-2 mb-xl-0 card-data" :class="{'d-none d-xl-block': [4,5].includes(index)}" v-for="(data, key, index) in post.insights" :key="key">
                                        <div class="row">
                                            <div class="col-12 mb-0 mb-xl-1">
                                                {{ (key.charAt(0).toUpperCase() + key.slice(1)).replace(/_/g, " ") }}
                                            </div>
                                            <div class="col-12 h-100">
                                                <h5 class="mb-0">{{ data.toLocaleString() }}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <infinite-loading v-if="page < lastPage" @infinite="infiniteHandler"></infinite-loading>
    </div>
</template>

<style scoped>

</style>
